import { DebounceTime, type HostedObserverConfig } from "@coze-studio/autosave";

import { type ParameterStoreProps, ParameterType } from "@rokid/store";
import { type ParameterConfig, ItemType } from "./type.ts";

type RegisterConfig = HostedObserverConfig<
  ParameterStoreProps,
  ItemType,
  ParameterConfig
>;

export const globalImagesizeConfig: RegisterConfig = {
  key: ItemType.globalImagesize,
  selector: (store) => {
    //因为服务端对于param_config是整个json存储，所以这里要所有属性都返回
    return {
      global_image_size: store.globalImagesize,
      param_type:store.inputParameterType
    }
  },
  debounce: {
    default: DebounceTime.Immediate,
    customized_suggest_prompt: DebounceTime.Long,
  },
  middleware: {
    onBeforeSave: (dataSource) => {
      return { param_config: dataSource };
    },
  },
};
